export default __webpack_public_path__ + "static/media/sheer bagh urdu.90fa7f56.png";